"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbIndex = void 0;
/**
 * Creates a new index instance which is needed to create an
 * database index.
 */
var DbIndex = /** @class */ (function () {
    /**
     * @param keys The name of the field which will be used
     * for the index,
     * an object of an field and index type combination or
     * an array of objects to create an compound index
     * @param unique Indicates if the index will be unique
     */
    function DbIndex(keys, unique) {
        if (typeof keys === 'string') {
            var key = {};
            key[keys] = DbIndex.ASC;
            this.keys = [key];
        }
        else if (Array.isArray(keys)) {
            this.keys = keys;
        }
        else if (keys) {
            this.keys = [keys];
        }
        else {
            throw new Error('The keys parameter must be an String, Object or Array.');
        }
        this.unique = unique === true;
    }
    /**
     * Returns DbIndex Object created from the given JSON
     * @param json
     * @return
     */
    DbIndex.fromJSON = function (json) {
        return new DbIndex(json.keys, json.unique);
    };
    /**
     * Indicates if this index is for the given field or includes it in a compound index
     * @param name The name of the field to check for
     * @return <code>true</code> if the index contains this field
     */
    DbIndex.prototype.hasKey = function (name) {
        for (var i = 0; i < this.keys.length; i += 1) {
            if (this.keys[i][name]) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(DbIndex.prototype, "isCompound", {
        /**
         * Indicates if this index is a compound index of multiple attributes
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.keys.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DbIndex.prototype, "isUnique", {
        /**
         * Indicates if this index is an unique index
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.unique;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a JSON representation of the Index object
     *
     * @return A Json of this Index object
     */
    DbIndex.prototype.toJSON = function () {
        return {
            unique: this.unique,
            keys: this.keys,
        };
    };
    DbIndex.ASC = 'asc';
    DbIndex.DESC = 'desc';
    return DbIndex;
}());
exports.DbIndex = DbIndex;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGJJbmRleC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkRiSW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBSUE7OztHQUdHO0FBQ0g7SUF1QkU7Ozs7OztPQU1HO0lBQ0gsaUJBQVksSUFBcUQsRUFBRSxNQUFnQjtRQUNqRixJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsRUFBRTtZQUM1QixJQUFNLEdBQUcsR0FBNEIsRUFBRSxDQUFDO1lBQ3hDLEdBQUcsQ0FBQyxJQUFJLENBQUMsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDO1lBQ3hCLElBQUksQ0FBQyxJQUFJLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUNuQjthQUFNLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztTQUNsQjthQUFNLElBQUksSUFBSSxFQUFFO1lBQ2YsSUFBSSxDQUFDLElBQUksR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3BCO2FBQU07WUFDTCxNQUFNLElBQUksS0FBSyxDQUFDLHdEQUF3RCxDQUFDLENBQUM7U0FDM0U7UUFFRCxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sS0FBSyxJQUFJLENBQUM7SUFDaEMsQ0FBQztJQTlCRDs7OztPQUlHO0lBQ1csZ0JBQVEsR0FBdEIsVUFBdUIsSUFBYTtRQUNsQyxPQUFPLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFpQixFQUFFLElBQUksQ0FBQyxNQUFpQixDQUFDLENBQUM7SUFDckUsQ0FBQztJQXlCRDs7OztPQUlHO0lBQ0gsd0JBQU0sR0FBTixVQUFPLElBQVk7UUFDakIsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUMsSUFBSSxDQUFDLEVBQUU7WUFDNUMsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxFQUFFO2dCQUN0QixPQUFPLElBQUksQ0FBQzthQUNiO1NBQ0Y7UUFDRCxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFPRCxzQkFBSSwrQkFBVTtRQUxkOzs7O1dBSUc7YUFDSDtZQUNFLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO1FBQzlCLENBQUM7OztPQUFBO0lBT0Qsc0JBQUksNkJBQVE7UUFMWjs7OztXQUlHO2FBQ0g7WUFDRSxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUM7UUFDckIsQ0FBQzs7O09BQUE7SUFFRDs7OztPQUlHO0lBQ0gsd0JBQU0sR0FBTjtRQUNFLE9BQU87WUFDTCxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU07WUFDbkIsSUFBSSxFQUFFLElBQUksQ0FBQyxJQUFJO1NBQ2hCLENBQUM7SUFDSixDQUFDO0lBdkZzQixXQUFHLEdBQUcsS0FBSyxDQUFDO0lBRVosWUFBSSxHQUFHLE1BQU0sQ0FBQztJQXNGdkMsY0FBQztDQUFBLEFBekZELElBeUZDO0FBekZZLDBCQUFPIn0=